import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import {
  CasesUnboxingComponent,
  CaseUnboxingSettings,
} from '../cases-unboxing/cases-unboxing.component';
import { CasesService } from '../services/cases.service';
import { ActivatedRoute } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';
import { SessionService } from '@core/services/session.service';
import { SocketService } from '@core/services/socket.service';
import { ToastrService } from 'ngx-toastr';
import { IWinSkin } from '../interfaces/cases.interface';

@Component({
  selector: 'app-cases-open',
  imports: [CasesUnboxingComponent, SvgIconComponent],
  templateUrl: './cases-open.component.html',
  styleUrl: './cases-open.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'container-xl',
  },
})
export class CasesOpenComponent {
  private route = inject(ActivatedRoute);
  private casesService = inject(CasesService);
  private sessionService = inject(SessionService);
  private socketService = inject(SocketService);
  private toastrService = inject(ToastrService);

  currentCase = computed(
    () =>
      this.casesService.findCaseByLink(
        this.route.snapshot.paramMap.get('link') ?? ''
      ) ?? null
  );

  unboxingConfig = computed<CaseUnboxingSettings>(() => {
    return {
      spinner: {
        amount: true,
      },
      caseItem: {
        detailsType: 'price' as const,
        locked: false,
      },
      balanceType: this.sessionService.balanceType(),
      openFn: (params: { amount?: number }) =>
        this.handleOpenCase(params.amount ?? 1),
    };
  });

  public async handleOpenCase(amount: number): Promise<IWinSkin[]> {
    const currentCase = this.currentCase();

    if (currentCase === null) {
      this.toastrService.error('Case not found');
      return [];
    }

    const response: IWinSkin[] = await this.socketService.emit('open_case', {
      case: currentCase.link,
      amount: amount,
      balance: this.sessionService.balanceType(),
    });

    return response;
  }
}
